<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container *ngIf="!!user?.id">
        Edit User
      </ng-container>
      <ng-container *ngIf="!user?.id">
        Add User
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" role="form" autocomplete="off">
      <div class="form-group row">
        <label for="name" class="col-3 col-form-label">Name</label>
        <div class="col-9">
          <input [(ngModel)]="user.name" [ngModelOptions]="{standalone: true}" type="email" class="form-control" id="name" placeholder="Name">
        </div>
      </div>

      <div class="form-group row">
        <label for="inputEmail" class="col-3 col-form-label">Email</label>
        <div class="col-9">
          <input [(ngModel)]="user.email" [ngModelOptions]="{standalone: true}" type="email" class="form-control" id="inputEmail" placeholder="Email">
        </div>
      </div>

      <div class="form-group row">
        <label for="roles" class="col-3 col-form-label">Roles</label>
        <div class="col-9">
          <ng-select2 id="roles" [(ngModel)]="selectedRoles" [ngModelOptions]="{standalone: true}" [data]="allRoles" [options]="select2options"></ng-select2>
        </div>
      </div>

      <div class="form-group row">
        <label for="participants" class="col-3 col-form-label">Participants</label>
        <div class="col-9">
          <ng-select2 id="participants" [(ngModel)]="selectedParticipants" [ngModelOptions]="{standalone: true}" [data]="allParticipants" [options]="select2options"></ng-select2>
        </div>
      </div>

      <div class="form-group row" *ngIf="showSuperUserToggle()">
        <div class="col-3">
          <label class="col-form-label m-auto">Super User</label>
        </div>
        <div class="col-9">
          <div class="btn-group btn-group-toggle p-2" ngbRadioGroup name="radioBasic" [(ngModel)]="isSuperUser">
            <label ngbButtonLabel class="btn-primary">
              <input ngbButton type="radio" [value]="true"> Yes
            </label>
            <label ngbButtonLabel class="btn-primary">
              <input ngbButton type="radio" [value]="false"> No
            </label>
          </div>
        </div>
      </div>

      <div class="form-group row offset-3 col-9" *ngIf="!!registerResult && registerResult.success == false">
        <ng-container *ngIf="!!registerResult.message">
          <p class="text-danger">{{registerResult.message}}</p>
        </ng-container>
        <ng-container *ngIf="!!registerResult.identityResult">
          <ng-container *ngFor="let error of registerResult.identityResult.errors">
            <p class="col-12 text-danger">{{error.description}}</p>
          </ng-container>
        </ng-container>
      </div>

      <div class="form-group row float-right">
        <div class="col-12">
          <button type="submit" *ngIf="canActivate" class="btn waves-effect waves-light mr-1" [ngClass]="{ 'btn-danger': !!user.isActive, 'btn-success': !user.isActive }" (click)="toggleActiveStatus()">{{ !!user.isActive ? 'Deactivate' : 'Activate' }}</button>
          <button type="button" *ngIf="userInactivate" class="btn btn-info waves-effect waves-light mr-1" (click)="resendActivationEmail()"><i class="mdi mdi-email-outline mr-1"></i>Resend Activation Email</button>
          <button type="submit" *ngIf="canDelete" class="btn waves-effect waves-light mr-1" [ngClass]="{ 'btn-danger': true }" (click)="delete()"><i class="mdi mdi-delete-outline mr-1"></i>Delete</button>
          <button type="button" class="btn btn-info waves-effect waves-light" (click)="save()"><i class="mdi mdi-content-save mr-1"></i>{{ !!user.id ? 'Save' : 'Create' }}</button>
        </div>
      </div>
    </form>
  </div>
</div>
